import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { Grid, Col } from '@koaly/grid';
import { MultiplyIcon } from '@koaly/koaly-ui-icons';
import { getSizeToken, getVariantToken, rem, spacing } from '@koaly/mixins';
import FocusTrap from 'focus-trap-react';
import { createElement } from 'react';
import { TouchScrollable } from 'react-scrolllock';
import { CSSTransition } from 'react-transition-group';
import { up, down } from 'styled-breakpoints';
import styled, { css } from 'styled-components';
import { useLinkWrapper } from '../../hooks/useLinkWrapper.js';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../Button/ButtonGroup/ButtonGroup.js';
import { Dimmer } from '../Dimmer/Dimmer.js';
import { DrawerUtilities } from '../Drawer/Drawer.js';
import { Heading } from '../Heading/Heading.js';
import { Portal } from '../Portal/Portal.js';
import { SvgButton } from '../SvgButton/SvgButton.js';

const StyledModal = styled.div.withConfig({ shouldForwardProp: (props) => !['width', 'height', 'maxWidth'].includes(props) })(({ zIndex, width, maxWidth, height, variant, size }) => css `
    border-radius: ${getSizeToken('modal', 'borderRadius', size)};
    padding: ${getSizeToken('modal', 'mobilePadding', size)};
    background-color: ${getVariantToken('modal', 'backgroundColor', variant)};

    top: 50%;
    left: 50%;
    z-index: ${zIndex};
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    position: fixed;
    max-height: 100vh;
    overflow: scroll;

    ${up('s')} {
      max-height: 90vh;
      padding: ${getSizeToken('modal', 'padding')};
      ${width && `width: ${width};`};
      ${height && `height: ${height};`};
      ${maxWidth && `max-width: ${maxWidth};`};
    }

    ${down('xs')} {
      width: 100vw;
      height: 100vh;
      border-radius: 0;
    }
  `);
StyledModal.defaultProps = {
    width: '70%',
    maxWidth: rem(700),
};
const StyledChildren = styled.div `
  margin-bottom: ${spacing(16)};
`;
const Modal = ({ open, onClose, title, buttons, maxWidth, children, zIndex, width, height, variant, size, }) => {
    const linkWrap = useLinkWrapper();
    return (createElement(CSSTransition, { in: open, timeout: 200, unmountOnExit: true },
        createElement(Portal, null,
            createElement(FocusTrap, { focusTrapOptions: { clickOutsideDeactivates: true, fallbackFocus: 'div' } },
                createElement(TouchScrollable, null,
                    createElement(StyledModal, { zIndex: zIndex, width: width, maxWidth: maxWidth, height: height, variant: variant, size: size },
                        createElement(Grid, null,
                            createElement(Col, null,
                                createElement(Heading, { size: "h2", spaceAfter: 6 }, title)),
                            createElement(Col, { width: 25, flex: true, halign: "right", valign: "top" },
                                createElement(SvgButton, { onClick: onClose },
                                    createElement(MultiplyIcon, { title: "Close modal", width: 25, height: 25 })))),
                        createElement(StyledChildren, null, children),
                        buttons && (createElement(ButtonGroup, { spacing: 4 }, buttons.map((_a, i) => {
                            var { label } = _a, rest = __rest(_a, ["label"]);
                            return linkWrap(createElement(Button, Object.assign({}, rest, { key: i + '-button-modal', size: "medium", elevation: 2 }), label));
                        })))))),
            createElement(Dimmer, { zIndex: 2, onClick: onClose }),
            createElement(DrawerUtilities, { onClose: onClose, hasScrollLock: true }))));
};
Modal.defaultProps = {
    zIndex: 101,
};

export { Modal };
//# sourceMappingURL=Modal.js.map
